import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useComponentTypesContext } from "../componentTypes/context/ComponentTypeContext";
import { getComponentTypes } from "../componentTypes/repositories/ComponentTypes";
import { usePartComponentTypeContext } from "../partComponentTypes/context/PartComponentTypeContext";
import { getPartComponentType } from "../partComponentTypes/repositories/PartComponentTypeRepository";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { useVendorsContext } from "../vendors/context/VendorsContext";
import { getVendors } from "../vendors/repositories/VendorsRepository";
import { PartsTableData } from "./components/DataTable/PartsTableData";
import { usePartsContext } from "./context/PartsContext";
import { getParts } from "./repositories/PartsRepository";

export const Parts = () => {
	const { state, actions } = usePartsContext();
	const { state: vendors, actions: vendorsActions } = useVendorsContext();
	const { state: componentTypesState, actions: componentTypesActions } =
		useComponentTypesContext();
	const { state: partComponentType, actions: partComponentTypeActions } =
		usePartComponentTypeContext();
	const { state: rootType, actions: rootTypeActions } = useRootTypeContext();

	const [isLoading, setIsLoading] = useState(true);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getPartsFromAPI = async () => {
		setIsLoading(true);

		const values = await Promise.all([
			getParts(),
			getVendors(),
			getPartComponentType(),
			getComponentTypes(),
			getRootTypes(),
		])
			.then((r) => {
				const [
					partsResp,
					{ vendors },
					partComponentTypeResp,
					{ componentTypes },
					{ rootTypes },
				] = r;

				if (partsResp.ok) {
					actions.setParts(partsResp.data?.data);
					vendorsActions.setVendors(vendors);
					partComponentTypeActions.setPartComponentType(
						partComponentTypeResp.data?.data,
					);
					componentTypesActions.setComponentTypes(componentTypes);
					rootTypeActions.setRootTypes(rootTypes);

					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
				setShowErrorModal(true);
			});
	};

	useEffect(() => {
		getPartsFromAPI();
	}, []);

	if (state.parts) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<PartsTableData
								isLoading={isLoading}
								getPartsFromAPI={getPartsFromAPI}
							/>
						</div>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
